document.addEventListener('bundler:loaded', function (e) {
  console.log('get budlez', window.bndlr.getBundles());
  const activeBundles = window.bndlr.getBundles();

  // Ensure compare price is visible if it exists (for collection discounts)
  const comparePriceElement = document.getElementById('total-compare-price');
  if (comparePriceElement) {
    const comparePrice = comparePriceElement.getAttribute('data-compare-price');
    if (comparePrice && comparePrice !== 'null' && comparePrice !== '') {
      comparePriceElement.style.display = '';
    }
  }

  let volumeDiscounts = [];
  let currentBundle = null;
  let currentProductHandle = document.querySelector('[data-product-handle]').getAttribute('data-product-handle');
  let currentProductId = document.querySelector('[data-product-id]')?.getAttribute('data-product-id');

  function getDiscountedPrice(quantity, originalPrice) {
    for (let i = volumeDiscounts.length - 1; i >= 0; i--) {
      if (quantity >= volumeDiscounts[i].min_items) {
        const discountValue = parseFloat(volumeDiscounts[i].discount_value);
        if (volumeDiscounts[i].discount_type === 'percentage') {
          return originalPrice * (1 - discountValue / 100);
        } else if (volumeDiscounts[i].discount_type === 'fixed_amount') {
          return Math.max(0, originalPrice - discountValue);
        }
      }
    }
    return originalPrice;
  }

  /** Geeft staffel-prijs per stuk in centen. Wordt o.a. gebruikt voor de hoofdtotaalprijs. */
  window.getStaffelDiscountedUnitPriceCents = function (quantity, unitPriceCents) {
    if (!volumeDiscounts || volumeDiscounts.length === 0) return unitPriceCents;
    const unitPriceEuros = parseFloat(unitPriceCents) / 100;
    const discountedEuros = getDiscountedPrice(parseInt(quantity, 10) || 1, unitPriceEuros);
    return Math.round(discountedEuros * 100);
  };

  /** Geeft staffel-totaal voor de regel in centen, met één afronding (zoals de app). */
  window.getStaffelDiscountedTotalCents = function (quantity, unitPriceCents) {
    if (!volumeDiscounts || volumeDiscounts.length === 0) return Math.round((parseFloat(unitPriceCents) * (parseInt(quantity, 10) || 1)));
    const qty = parseInt(quantity, 10) || 1;
    const unitPriceEuros = parseFloat(unitPriceCents) / 100;
    const discountedPerUnitEuros = getDiscountedPrice(qty, unitPriceEuros);
    const totalDiscountedEuros = discountedPerUnitEuros * qty;
    return Math.round(totalDiscountedEuros * 100);
  };

  function displayVolumeDiscounts(volumeDiscounts) {
    const volumeDiscountContainer = document.querySelector('#volume-discount-container');
    const priceContainer = document.querySelector('#total-price');
    const comparePriceContainer = document.querySelector('#total-compare-price');

    if (!volumeDiscountContainer) {
      console.error('Volume discount container not found');
      return;
    }
    if (!priceContainer) {
      console.error('Price container not found');
      return;
    }

    volumeDiscountContainer.innerHTML = '';
    // Use unit price (per piece) for staffel calculation - stays correct when variant changes
    const unitPriceCents = priceContainer.getAttribute('data-unit-price') || priceContainer.getAttribute('data-price') || '0';
    const unitCompareCents = comparePriceContainer?.getAttribute('data-unit-compare-price') || comparePriceContainer?.getAttribute('data-compare-price') || '0';
    const originalPrice = parseFloat(unitPriceCents) / 100;
    const originalComparePrice = parseFloat(unitCompareCents) / 100;

    volumeDiscounts.forEach((discount) => {
      const quantity = discount.min_items;
      const discountValue = discount.discount_value;
      const discountType = discount.discount_type;
      let discountedPrice, discountAmount, discountSymbol;
      let discountComparePrice, discountCompareAmount;

      if (discountType === 'percentage') {
        discountedPrice = originalPrice * (1 - discountValue / 100);
        discountAmount = originalPrice - discountedPrice;
        discountSymbol = '%';
        discountComparePrice = originalComparePrice * (1 - discountValue / 100);
        discountCompareAmount = originalComparePrice - discountComparePrice;
      } else if (discountType === 'fixed_amount') {
        discountedPrice = originalPrice - discountValue;
        discountAmount = discountValue;
        discountSymbol = '';
        discountComparePrice = originalComparePrice - discountValue;
        discountAmount = discountValue;
      }

      const totalDiscountAmount = discountAmount * quantity;
      const formattedDiscountedPrice = formatMoney(discountedPrice * 100, '{{amount_with_comma_separator}}');
      const formattedDiscountedComparePrice = formatMoney(
        discountComparePrice * 100,
        '{{amount_with_comma_separator}}'
      );
      const formattedTotalDiscountAmount = formatMoney(totalDiscountAmount * 100, '{{amount_with_comma_separator}}');

      // Only show compare price if it exists and is greater than 0
      const comparePriceHtml =
        originalComparePrice > 0
          ? `
        <span class="line-through mr-1 md:mr-3 text-warning text-body md:text-xs" data-excl-price="${
          discountComparePrice * 100
        }">
            €${formattedDiscountedComparePrice}
        </span>
      `
          : '';

      const discountHtml = `
  <div class="flex hover-staffel cursor-pointer border border-[#DDD9D9] w-full rounded-full gap-0" data-volume-quantity="${quantity}">
    <div class="flex w-full justify-between px-3 md:px-6 items-center">
      <div class="flex items-center justify-center gap-2 py-2">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="staffel-circle">
            <!-- Outer circle (always visible) -->
            <circle cx="7" cy="7" r="6.5" stroke="#E8E8E8" fill="none"/>
            <!-- Inner filled circle (hidden by default, shown when selected) -->
            <circle cx="7" cy="7" r="4" fill="#183B64" class="fill-circle hidden"/>
          </svg>
          <span class="text-body md:text-sm whitespace-nowrap">${quantity} stuks</span>
      </div>

      <div class="flex items-end sm:items-center justify-center col-span-2 md:col-span-4 py-2.5 font-light text-xs md:text-sm w-full">
        <div class="flex flex-row">
          ${comparePriceHtml}
          <span class="font-bold text-body md:text-h5" data-excl-price="${discountedPrice * 100}">
              €${formattedDiscountedPrice}
          </span>
        </div> 
        <span class="text-body md:text-xs">&nbsp per stuk</span>
      </div>
    </div>

    <div class="flex items-center w-auto pl-3 pr-8 justify-center py-2 whitespace-nowrap text-intense hover-staffel-last text-xs md:text-sm font-bold text-center" style="min-width: 75px">
      <span class="hidden md:block">
        <span data-excl-price="${totalDiscountAmount * 100}">€${formattedTotalDiscountAmount}</span> 
        voordeel
      </span> 
      <span class="md:hidden">
        <span data-excl-price="${totalDiscountAmount * 100}">-€${formattedTotalDiscountAmount}</span>
      </span> 
    </div>
  </div>

      `;

      volumeDiscountContainer.innerHTML += discountHtml;
    });

    // Notify that staffel DOM was updated so click listeners can be re-attached
    document.dispatchEvent(new CustomEvent('volume-discounts-refreshed'));
  }

  // Expose refresh so variant picker can re-render staffels when variant (or delivery) changes
  window.refreshVolumeDiscounts = function () {
    if (volumeDiscounts && volumeDiscounts.length > 0) {
      displayVolumeDiscounts(volumeDiscounts);
    }
  };

  async function displayBundleProducts(products) {
    const bundleSelector = document.querySelector('[data-bundle-selector]');
    if (!bundleSelector) return;

    bundleSelector.innerHTML = '';
    const discountPercentage = parseFloat(currentBundle.percentage_value) / 100;

    // Handle the current product (hidden from frontend)
    const currentProduct = Object.values(products).find((p) => p.handle === currentProductHandle);
    if (currentProduct) {
      const fullProductData = await fetchProductData(currentProduct.handle);
      if (fullProductData) {
        const variant = fullProductData.variants[0]; // Assuming first variant

        const originalPrice = variant.price;
        const discountedPrice = originalPrice * (1 - discountPercentage);

        // Add a hidden element to store current product information
        bundleSelector.innerHTML += `
          <div data-product-id="${currentProduct.id}" data-variant-id="${variant.id}" style="display: none;">
            <input
              type="checkbox"
              checked
              disabled
            >
            <span data-original-price="${originalPrice}" data-discounted-price="${discountedPrice}"></span>
          </div>
        `;

        // Add the current product to the bundle only if it hasn't been added yet
        if (!currentProductAdded) {
          addCurrentProductToBundle(currentProduct.id, variant.id);
        }
      }
    }

    // Display other products in the bundle selector
    for (const product of Object.values(products)) {
      if (product.handle !== currentProductHandle) {
        const fullProductData = await fetchProductData(product.handle);
        if (!fullProductData) continue;

        const variant = fullProductData.variants[0]; // Assuming first variant

        const originalPrice = variant.price;
        const discountedPrice = originalPrice * (1 - discountPercentage);
        const imageUrl = fullProductData.featured_image || 'path/to/default/image.jpg';

        bundleSelector.innerHTML += `
          <div data-product-id="${product.id}" data-variant-id="${
          variant.id
        }" class="min-h-[302px] bg-white relative border border-[#DDD9D9] p-3 col-span-12 lg:col-span-4 flex flex-row xl:flex-col items-center gap-3 md:gap-6 xl:gap-0">
            <div class="flex items-center mb-4 absolute right-3 top-3">
              <input
                type="checkbox"
                class="!mr-0 !w-5 !h-5 text-hightlight_light !rounded-none cursor-pointer"
                onChange="toggleInBundle(event, '${product.id}', '${variant.id}', ${product.sequence})"
              >
            </div>
            <img
              src="${imageUrl}"
              alt="${fullProductData.title}"
              class="w-36 h-36 xl:h-auto xl:w-full object-cover aspect-square xl:mb-4"
              width="200"
              height="200"
            > 
            <div>
              <p class="font-bold text-base md:text-lg mb-1">${fullProductData.title}</p>
              <div class="flex flex-wrap items-center gap-2">
                <p class="text-[#6E6E6E] text-xs line-through">${formatMoney(
                  originalPrice,
                  '€{{amount_with_comma_separator}}'
                )}</p>
                <p class="text-base font-bold" data-original-price="${originalPrice}" data-discounted-price="${discountedPrice}">${formatMoney(
          discountedPrice,
          '€{{amount_with_comma_separator}}'
        )}</p>
              </div>
            </div>
          </div>
        `;
      }
    }
    updateBundlePrice();
  }

  activeBundles.forEach((bundle) => {
    console.log('Checking bundle:', bundle);

    if (bundle.is_volume_bundle === 'true' && bundle.volume_discounts && bundle.volume_discounts.length > 0) {
      // Check if the current product is in this volume discount bundle
      const bundleProduct = Object.values(bundle.products).find((p) => p.handle === currentProductHandle);
      if (bundleProduct) {
        console.log('Volume discount bundle found for current product', bundle);
        volumeDiscounts = bundle.volume_discounts;
        displayVolumeDiscounts(bundle.volume_discounts);
      }
    } else if (bundle.products && Object.keys(bundle.products).length > 0) {
      // Handle regular bundles (not just hardcoded ID)
      currentBundle = bundle;
      console.log('Regular bundle found', bundle);
      if (Object.values(bundle.products).some((p) => p.handle === currentProductHandle)) {
        displayBundleProducts(bundle.products);
      } else {
        console.log('Product not in bundle');
        const bundlesElement = document.querySelector('#bundles');
        if (bundlesElement) {
          bundlesElement.style.display = 'none';
        }
        const miniMenuLink = document.querySelector('.mini-menu a[href="#bundles"]');
        if (miniMenuLink) {
          miniMenuLink.parentNode.style.display = 'none';
        }
      }
    }
  });

  // Add an event listener to the quantity input
  const quantityInput = document.querySelector('[action="/cart/add"] .product-form__quantity input');
  const totalPriceElement = document.getElementById('total-price');

  // Add error handling for missing elements
  if (!totalPriceElement) {
    console.error('Total price element not found');
    return;
  }

  const originalPrice = parseFloat(totalPriceElement.getAttribute('data-original-price'));

  // Modify the event listener for the quantity input
  if (quantityInput && totalPriceElement) {
    quantityInput.addEventListener('change', function () {
      console.log('Quantity changed');
      const quantity = parseInt(this.value, 10);
      const originalPrice = parseFloat(totalPriceElement.getAttribute('data-original-price'));
      console.log('Original price from attribute:', originalPrice);
      const discountedPrice = getDiscountedPrice(quantity, originalPrice);
      const totalPrice = discountedPrice * quantity;

      console.log('Calculated total price:', totalPrice);
      const exclCents = Math.round(totalPrice * 100);
      totalPriceElement.textContent = formatMoney(exclCents, '€{{amount_with_comma_separator}}');
      totalPriceElement.setAttribute('data-excl-price', exclCents);
      const totalPriceInclEl = document.getElementById('total-price-incl');
      if (totalPriceInclEl) {
        const inclCents = Math.round(exclCents * 1.21);
        totalPriceInclEl.textContent = '€' + formatMoney(inclCents, '{{amount_with_comma_separator}}') + ' incl btw';
        totalPriceInclEl.setAttribute('data-excl-price', exclCents);
      }

      // Preserve compare price visibility (for collection discounts)
      if (
        comparePriceElement &&
        comparePriceElement.getAttribute('data-compare-price') &&
        comparePriceElement.getAttribute('data-compare-price') !== 'null'
      ) {
        comparePriceElement.style.display = '';
      }
    });
  }

  // Modify the setQuantity function
  window.setQuantity = function (quantity) {
    console.log('Set quantity: ', quantity);
    quantityInput.value = quantity;
    const originalPrice = parseFloat(totalPriceElement.getAttribute('data-original-price'));
    console.log('Original price from attribute:', originalPrice);
    const discountedPrice = getDiscountedPrice(quantity, originalPrice);
    const totalPrice = discountedPrice * quantity;
    console.log('Calculated total price:', totalPrice);
    const exclCents = Math.round(totalPrice * 100);
    totalPriceElement.textContent = formatMoney(exclCents, '€{{amount_with_comma_separator}}');
    totalPriceElement.setAttribute('data-excl-price', exclCents);
    const totalPriceInclEl = document.getElementById('total-price-incl');
    if (totalPriceInclEl) {
      const inclCents = Math.round(exclCents * 1.21);
      totalPriceInclEl.textContent = '€' + formatMoney(inclCents, '{{amount_with_comma_separator}}') + ' incl btw';
      totalPriceInclEl.setAttribute('data-excl-price', exclCents);
    }

    // Preserve compare price visibility (for collection discounts)
    if (
      comparePriceElement &&
      comparePriceElement.getAttribute('data-compare-price') &&
      comparePriceElement.getAttribute('data-compare-price') !== 'null'
    ) {
      comparePriceElement.style.display = '';
    }
  };

  // Keep existing functions
  async function fetchProductData(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching product data:', error);
      return null;
    }
  }

  let currentProductAdded = false;

  function addCurrentProductToBundle(productId, variantId) {
    const product = document.querySelector(`.bndlr-product.bndlr-mix-and-match[data-product-id="${productId}"]`);
    if (product) {
      const addButton = product.querySelector('.bndlr-add-to-bundle');
      if (addButton) {
        addButton.click();
        currentProductAdded = true;
        console.log('Current product added to bundle');
      } else {
        console.error(`Add button not found for current product: ${productId}`);
      }
    } else {
      console.error(`Product element not found for current product: ${productId}`);
    }
  }

  window.toggleInBundle = function (event, productId, variantId, index) {
    console.log('event', event.target.checked);
    console.log('productId', productId);

    const product = document.querySelector(`.bndlr-product.bndlr-mix-and-match[data-product-id="${productId}"]`);
    console.log(product);

    if (!product) {
      console.error(`Product element not found for productId: ${productId}`);
      return;
    }

    if (event.target.checked) {
      const addButton = product.querySelector('.bndlr-add-to-bundle');
      if (addButton) {
        addButton.click();
      } else {
        console.error(`Add button not found for productId: ${productId}`);
      }
    } else {
      const targetProduct = document.querySelector(
        `.bndlr-mnm-selected-products .bndlr-product[data-variant-id="${variantId}"]`
      );
      if (targetProduct) {
        const removeButton = targetProduct.querySelector('.bndlr-close');
        if (removeButton) {
          removeButton.click();
        } else {
          console.error(`Remove button not found for variantId: ${variantId}`);
        }
      } else {
        console.error(`Target product not found for variantId: ${variantId}`);
      }
    }

    updateBundlePrice();
  };

  window.updateBundlePrice = function () {
    if (!currentBundle) return;

    var bundleContainer = document.getElementById('bundles');
    var productPrice = bundleContainer.getAttribute('data-main-product-price');

    const mainProductPrice = parseFloat(productPrice);
    let totalPrice = 0;

    const allProducts = document.querySelectorAll('[data-bundle-selector] [data-product-id]');
    const checkedProducts = document.querySelectorAll('[data-bundle-selector] input[type="checkbox"]:checked');

    checkedProducts.forEach((checkbox) => {
      const productElement = checkbox.closest('[data-product-id]');
      const price = parseFloat(
        productElement.querySelector('[data-discounted-price]').getAttribute('data-discounted-price')
      );
      totalPrice += price;
    });

    const bundlePriceElement = document.querySelector('[data-bundle-price]');
    bundlePriceElement.innerHTML = formatMoney(totalPrice, '€{{amount_with_comma_separator}}');

    allProducts.forEach((productElement) => {
      if (productElement.style.display !== 'none') {
        const checkbox = productElement.querySelector('input[type="checkbox"]');
        const priceElement = productElement.querySelector('[data-discounted-price]');
        const originalPrice = parseFloat(priceElement.getAttribute('data-original-price'));
        const discountedPrice = parseFloat(priceElement.getAttribute('data-discounted-price'));

        if (checkbox.checked) {
          priceElement.textContent = formatMoney(discountedPrice, '€{{amount_with_comma_separator}}');
          priceElement.classList.add('text-green-500');
        } else {
          priceElement.textContent = formatMoney(discountedPrice, '€{{amount_with_comma_separator}}');
          priceElement.classList.remove('text-green-500');
        }
      }
    });
  };

  window.addBundleToCart = function () {
    // First, ensure the current product is added to the bundle
    const currentProductCheckbox = document.querySelector(
      '[data-bundle-selector] [data-product-id] input[type="checkbox"]:disabled'
    );
    if (currentProductCheckbox) {
      const productId = currentProductCheckbox.closest('[data-product-id]').getAttribute('data-product-id');
      const variantId = currentProductCheckbox.closest('[data-variant-id]').getAttribute('data-variant-id');
      const addButton = document.querySelector(
        `.bndlr-product.bndlr-mix-and-match[data-product-id="${productId}"] .bndlr-add-to-bundle`
      );
      if (addButton) {
        addButton.click();
      }
    }

    // Then add the rest of the bundle to cart
    const atcButton = document.querySelector('.bndlr-add-bundle-to-cart');
    atcButton.click();
  };

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '€{{amount}}';

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, '.');
      decimal = defaultOption(decimal, ',');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }
});
